<div class="exprx--common-block">
  <div class="eprx--block__header">
    <div class="eprx--header__heading">
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-9">
              <div class="eprx--header__heading">
                <div class="col-sm-12 padding-0">
                  <div class="row">
                    <div class="col-md-10">
                      <span>Facility Admit / Discharge History</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-3">
              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <div class="col-11 text-end">
                      <button id="patAddBut" class="hotkey_primary--Override" [ngClass]="filteredGroups?.length && !filteredGroups[0]?.fg?.value?.['Id'] ? 'inactive' : 'hotkey_success'"
                        appTooltip="{{!filteredGroups?.length || filteredGroups[0]?.fg?.value?.['Id'] ? 'Create Admission' : 'Please save the facility information before creating a new admission'}}" appShortcutKey [AltKey]="'a'"
                        [disabled]="filteredGroups?.length && !filteredGroups[0]?.fg?.value?.['Id']"
                        (click)="requestCreateAdmission()"><span>A</span>Create Admission
                      </button>
                    </div>
                    <div class="col-1 padding--left__0">
                      <app-user-guide-icon [ActiveTabId]="'PatientFacilityInfo'"></app-user-guide-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="eprx--block__content pt-0">
    <div class="eprx--block__content patient-facility my-2 border_10" *ngIf="facilityCodeOptions.length > 1">
      <div class="col-md-4 facility-filter collapsed-row">
        <div class="d-flex align-items-top">
          <i class="far fa-filter actions mt-2 me-2" appCustomTooltip="Search Filter"></i>
          <label class="mt-2 me-2" style="white-space: nowrap;">Filter by Facility</label>
          <div class="flex-grow-1">
            <eprx-select [RxSelectId]="'facilityFilter'" [LabelText]="''" [PlaceHolder]="''" [HasControl]="false"
              [HasMultiple]="false" [List]="facilityCodeOptions" [InputValue]="filterFacilityId"
              [BindLabel]="'FacilityCode'" [BindValue]="'Id'" [LabelForId]="'FacilityCode'" [HasBindLabel2]="true"
              [Show2Values]="true" [BindLabel2]="'FacilityName'" [LabelTitle1]="'CODE'" [LabelTitle2]="'NAME'"
              (TriggerSelectValue)="onFacilityFilterChange($event)">
            </eprx-select>
          </div>
        </div>
      </div>
    </div>
    <app-no-data-found *ngIf="filteredGroups.length === 0"></app-no-data-found>
    <div class="facility-scroll-content" [ngClass]="filteredGroups.length === 1 && !filteredGroups[0].fg.value['Id'] ? 'mt-2' : ''">
      <ng-container *ngFor="let item of filteredGroups; trackBy: trackByFilteredItem">
        <div class="mb-3 patient-facility">
          <div class="row">
            <div class="col-lg-12">
              <div class="eprx--block__content"
                [ngClass]="expandedIndex === item.originalIndex ? 'expanded-row' : 'collapsed-row'">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-lg-10">
                      <div class="row">
                        <div class="col-lg-2 col-md-2 col-sm-2 text-wrap">
                          <label>Facility</label>
                          <div>{{ (item.fg.value["FacilityName"] || "--") | uppercase }}</div>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-2 text-wrap">
                          <label>Physician</label>
                          <div>{{ (item.fg.value["PrescribName"] || "--") | uppercase }}</div>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-2 text-wrap">
                          <label>Admit Date</label>
                          <div>{{ formatDate(item.fg.value["AdmitDt"]) }}</div>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-2 text-wrap">
                          <label>Discharge Date</label>
                          <div>{{ formatDate(item.fg.value["DischargeDt"]) }}</div>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-2 text-wrap">
                          <label>Location</label>
                          <div>{{ (item.fg.value["FacLocationName"] || "--") | uppercase }}</div>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-2 text-wrap status-cell">
                          <div class="d-flex flex-column align-items-center">
                            <label class="text-center d-block">Status</label>
                            <div [ngClass]="rowStates[item.originalIndex]?.statusClass">{{
                              rowStates[item.originalIndex]?.statusText }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 mt-1 text-end">
                      <span class="row-action-icons">
                        <i *ngIf="!rowStates[item.originalIndex]?.isNew"
                          class="far fa-edit actions actions--Highlightfocus--icon" appCustomTooltip="Edit"
                          [class.disabled-icon]="!canEdit(item.originalIndex)"
                          (click)="canEdit(item.originalIndex) && editRow(item.originalIndex)"></i>
                        <i *ngIf="!rowStates[item.originalIndex]?.isNew" class="far fa-trash-alt actions danger-actve"
                          appCustomTooltip="Delete" [class.disabled-icon]="!canEdit(item.originalIndex)"
                          (click)="requestDeleteRowConfirm(deletePatFacility, item.originalIndex)"></i>
                        <i class="far action-arrow"
                          [ngClass]="expandedIndex === item.originalIndex ? 'fa-angle-down' : 'fa-angle-left'"
                          aria-hidden="true" (click)="toggleRow(item.originalIndex)"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="eprx--block__content" *ngIf="isExpanded(item.originalIndex)">
            <div class="row">
              <div class="col-md-3">
                <eprx-select [RxSelectId]="'Facility' + item.originalIndex" [LabelText]="'Facility Code'"
                  [PlaceHolder]="'Facility Code'" [secondCntrlN]="'FacilityName'" [ControlName]="'FacilityId'"
                  [FormGroupName]="item.fg" [IsFirstElem]="item.originalIndex === 0" [HasMultiple]="false"
                  [HasBindLabel2]="true" [Show2Values]="true" [BindLabel2]="'FacilityName'" [BindLabel]="'FacilityCode'"
                  [bindScnCntrlV]="'FacilityName'" [BindValue]="'Id'" [LabelForId]="''" [List]="facilityInfo?.Facility"
                  [IsRequired]="true"
                  [IsDisabled]="rowStates[item.originalIndex]?.discharged || (item.fg.value['Id'] > 0 && rowStates[item.originalIndex]?.disabled)"
                  [MarkAsTouched]="item.fg?.get('FacilityId')?.touched"
                  (TriggerSelectValue)="getFacLoc(item.originalIndex, item.fg)"
                  (keydown.enter)="getFacLoc(item.originalIndex, item.fg)" [LabelTitle1]="'CODE'"
                  [LabelTitle2]="'NAME'"
                  [IsAppendTo]="true">
                </eprx-select>
              </div>
              <div class="col-md-3">
                <eprx-date-picker [RxSelectId]="'AdmitDtID' + item.originalIndex" [LabelText]="'Admit Date'"
                [ErrorDefs]="{required: 'Required', inValid:'Invalid Date', pattern: 'Invalid Date', maxDate:'Invalid Date'}"
                  [PlaceHolder]="''" [ControlName]="'AdmitDt'" [FormGroupName]="item.fg" [MinDate]=""
                  [MaxDate]="" [IsRequired]="rowStates[item.originalIndex]?.hasFacility"
                  [IsDisabled]="rowStates[item.originalIndex]?.disabled"
                  [MarkAsTouched]="item.fg?.get('AdmitDt')?.touched">
                </eprx-date-picker>
              </div>
              <div class="col-md-3">
                <eprx-input [LabelText]="'Physician'" [PlaceHolder]="'Physician'" [ControlName]="'PrescribName'"
                  [FormGroupName]="item.fg" [MaxLength]="250" [IsDisabled]="rowStates[item.originalIndex]?.disabled">
                </eprx-input>
              </div>
              <div
                class="col-md-3 seconday-search--grid common_global_search_max_content_display_for_Presc line_height_1">
                <label class="align-label">Primary Physician</label>
                <app-searchbox-global [SearchFor]="'Prescriber'" [DisableRadioButtons]="true" [IsAddNew]="false"
                  [notSelectSingleMatch]="true"
                  (SelectedPrescriber)="selectedPresInfo($event, item.originalIndex, item.fg)"
                  [ClearInputValue]="prescInputValues[item.originalIndex]"
                  [inputdisabled]="rowStates[item.originalIndex]?.disabled"
                  class="common_global_search_max_content_display_length_left"></app-searchbox-global>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <eprx-input [LabelText]="'Alternate Physician'" [PlaceHolder]="'Alternate Physician'"
                  [ControlName]="'AltPresName'" [FormGroupName]="item.fg" [MaxLength]="250"
                  [IsDisabled]="rowStates[item.originalIndex]?.disabled">
                </eprx-input>
              </div>
              <div class="col-md-3">
                <eprx-select [LabelText]="'Location'" [PlaceHolder]="'Location'" [secondCntrlN]="'FacLocationName'"
                  [ControlName]="'FacLocId'" [FormGroupName]="item.fg" [BindLabel]="'Id'" [BindValue]="'Id'"
                  [bindScnCntrlV]="'Name'" [LabelForId]="'Id'" [List]="getLocations(item.originalIndex)"
                  [BindLabel2]="'Name'" [Show2Values]="true" [IsDisabled]="rowStates[item.originalIndex]?.disabled">
                </eprx-select>
              </div>
              <div class="col-md-3">
                <eprx-select [LabelText]="'Station'" [PlaceHolder]="'Station'" [secondCntrlN]="'FacStationName'"
                  [ControlName]="'FacStationId'" [FormGroupName]="item.fg" [bindScnCntrlV]="'Name'" [BindLabel]="'Id'"
                  [BindValue]="'Id'" [LabelForId]="'Id'" [List]="getStations(item.originalIndex)" [BindLabel2]="'Name'"
                  [Show2Values]="true" [IsDisabled]="rowStates[item.originalIndex]?.disabled">
                </eprx-select>
              </div>
              <div class="col-md-3">
                <eprx-date-picker [RxSelectId]="'DischargeDtID' + item.originalIndex" [LabelText]="'Discharge Date'"
                [ErrorDefs]="{required: 'Required', inValid:'Invalid Date', pattern: 'Invalid Date', maxDate:'Invalid Date'}"
                  [PlaceHolder]="''" [ControlName]="'DischargeDt'" [FormGroupName]="item.fg" [MinDate]=""
                  [MaxDate]="" [IsRequired]="isDischargeDateRequired(item.originalIndex, item.fg)"
                  [MarkAsTouched]="item.fg?.get('DischargeDt')?.touched"
                  [IsDisabled]="rowStates[item.originalIndex]?.disabled">
                </eprx-date-picker>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <eprx-input [LabelText]="'MRN'" [PlaceHolder]="'Medical Record Number'" [ControlName]="'FacPatNum'"
                  [FormGroupName]="item.fg" [MaxLength]="50" [IsDisabled]="rowStates[item.originalIndex]?.disabled">
                </eprx-input>
              </div>
              <div class="col-md-3">
                <eprx-input [LabelText]="'Room'" [PlaceHolder]="'Room'" [ControlName]="'RoomNum'"
                  [FormGroupName]="item.fg" [InputType]="'NUMBER'" [MaxLength]="5"
                  [IsDisabled]="rowStates[item.originalIndex]?.disabled">
                </eprx-input>
              </div>
              <div class="col-md-3">
                <eprx-input [LabelText]="'Floor'" [PlaceHolder]="'Floor'" [ControlName]="'FloorNum'"
                  [FormGroupName]="item.fg" [InputType]="'NUMBER'" [MaxLength]="2"
                  [IsDisabled]="rowStates[item.originalIndex]?.disabled">
                </eprx-input>
              </div>
              <div class="col-md-3">
                <eprx-input [LabelText]="'Bed'" [PlaceHolder]="'Bed'" [ControlName]="'BedNum'" [FormGroupName]="item.fg"
                  [InputType]="'NUMBER'" [MaxLength]="4" [IsDisabled]="rowStates[item.originalIndex]?.disabled">
                </eprx-input>
              </div>
            </div>
            <div class="row remove--height__custom--input">
              <div class="col-md-3">
                <eprx-text-area [RxSelectId]="'DiagnosisNote' + item.originalIndex" [LabelText]="'Diagnosis Note'"
                  [ControlName]="'DiagnosisNote'" [FormGroupName]="item.fg" [PlaceHolder]="'Diagnosis Note'" [Rows]="2"
                  [ReadOnly]="rowStates[item.originalIndex]?.disabled">
                </eprx-text-area>
              </div>
              <div class="col-md-3">
                <eprx-text-area [RxSelectId]="'OrderNote' + item.originalIndex" [LabelText]="'Order Note'"
                  [ControlName]="'OrderNote'" [FormGroupName]="item.fg" [PlaceHolder]="'Order Note'" [Rows]="2"
                  [ReadOnly]="rowStates[item.originalIndex]?.disabled">
                </eprx-text-area>
              </div>
              <div class="col-md-3">
                <eprx-text-area [RxSelectId]="'DietNote' + item.originalIndex" [LabelText]="'Diet Note'"
                  [ControlName]="'DietNote'" [FormGroupName]="item.fg" [PlaceHolder]="'Diet Note'" [Rows]="2"
                  [ReadOnly]="rowStates[item.originalIndex]?.disabled">
                </eprx-text-area>
              </div>
              <div class="col-md-3">
                <eprx-text-area [RxSelectId]="'Remarks' + item.originalIndex" [LabelText]="'Miscellaneous'"
                  [ControlName]="'Remarks'" [FormGroupName]="item.fg" [PlaceHolder]="'Miscellaneous'" [Rows]="2"
                  [ReadOnly]="rowStates[item.originalIndex]?.disabled">
                </eprx-text-area>
              </div>
            </div>
            <div class="row mt-2"
              *ngIf="rowStates[item.originalIndex]?.isNew || rowStates[item.originalIndex]?.editing">
              <div class="col-12 text-end">
                <button class="hotkey_primary--Override me-2" [ngClass]="canSave(item.fg) ? 'hotkey_success' : 'inactive'" appShortcutKey [AltKey]="'s'"
                  [disabled]="!canSave(item.fg)"
                  appTooltip="{{canSave(item.fg) ? 'Save record.' : 'Only one active admission is allowed per patient.'}}"
                  (click)="canSave(item.fg) && requestSaveFacility(item.originalIndex, item.fg)"><span>S</span>Save</button>
                <button class="hotkey_success hotkey_primary--Override me-2" appShortcutKey [AltKey]="'o'" appTooltip="Cancel changes"
                  (click)="requestCancelNewRow(item.originalIndex, item.fg)"><span>O</span>Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
<ng-template #deletePatFacility let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title">Confirmation!</h4>
        <button
            type="button"
            [tabindex]="-1" class="close"
            aria-label="Close"
            (click)="d('Cross click')"
        >
            <span aria-hidden="true" class="close-button">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        Are you sure you want to delete this facility record?
    </div>
    <div class="modal-footer">
        <button
            type="button"
            class="hotkey_primary"
            (click)="confirmDeleteRow()"
            appShortcutKey InputKey="y"><b>Y</b> YES
        </button>
        <button type="button" class="hotkey_primary" (click)="cancelDeleteConfirmation()" appShortcutKey InputKey="n">
           <b>N</b> NO
        </button>
    </div>
</ng-template>